<mat-card [ngClass]="class">
  <mat-card-header>
    <mat-card-title *ngIf="title != ''"
      ><span class="mat-headline-5 title-information">{{
        title
      }}</span></mat-card-title
    >
    <mat-card-subtitle *ngIf="subtitle != ''"
      ><span class="mat-card-subtitle subtitle">{{ subtitle }}</span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content
    ><span class="mat-card-content content-text"><ng-content /></span
  ></mat-card-content>
</mat-card>
